import type { QuizConfig } from "../types"

export const demoQuiz: QuizConfig = {
  id: "demo",
  name: "Demo Quiz",
  steps: [
    {
      id: "goal",
      type: "single-choice",
      title: "What is your main goal?",
      subtitle: "This helps us personalize your experience",
      required: true,
      options: [
        { label: "Learn something new", value: "learn" },
        { label: "Improve my skills", value: "improve" },
        { label: "Just exploring", value: "explore" },
      ],
    },
    {
      id: "experience",
      type: "single-choice",
      title: "How would you describe your experience level?",
      required: true,
      options: [
        { label: "Beginner", value: "beginner" },
        { label: "Intermediate", value: "intermediate" },
        { label: "Advanced", value: "advanced" },
      ],
    },
    {
      id: "interests",
      type: "multiple-choice",
      title: "What topics interest you?",
      subtitle: "Select all that apply",
      required: true,
      options: [
        { label: "Health & Wellness", value: "health" },
        { label: "Personal Growth", value: "growth" },
        { label: "Productivity", value: "productivity" },
        { label: "Relationships", value: "relationships" },
        { label: "Career", value: "career" },
      ],
    },
    {
      id: "palmPhoto",
      type: "photo",
      title: "Take a photo of your palm",
      subtitle: "Spread your fingers and fit your palm inside the frame",
      cameraFacing: "environment",
      required: true,
    },
    {
      id: "email",
      type: "email",
      title: "Where should we send your plan?",
      subtitle: "We'll use this to create your account",
      placeholder: "you@example.com",
      required: true,
    },
  ],
}
